export const DonationType = {
    Online: 1,
    Offline: 2,
    Pledge: 3
};